import { useMemo } from 'react';
import { isAdmin } from '@/helpers/auth';
import { arraySortFuncMultiKeys } from '@/helpers/common/ArrayHelper';
import { isClient, isProfessional } from '@/utils/resources/auth/authResource';
const useMemberInfo = (rfp, profile, auth) => {
    const { members: rfpMembers, request_professional_organization_id: requestProfessionalOrganizationId, } = rfp;
    const { id, isAdmin: isProffitAdmin, organization } = profile;
    const { id: organizationId } = organization || {};
    return useMemo(() => {
        const isClientUser = isClient(auth);
        const isProfessionalUser = isProfessional(auth);
        const isRequestProfessional = isProfessionalUser &&
            organizationId &&
            requestProfessionalOrganizationId === organizationId;
        const members = rfpMembers.map((member) => ({
            clientId: member.client_id,
            email: member.email,
            firstName: member.first_name,
            id: member.id,
            isAdmin: member.is_admin,
            // 自分と責任者は消せない＋管理者ユーザーの場合は操作もさせない
            isCanDelete: !!(isClientUser &&
                member.client_id !== id &&
                !member.is_admin &&
                !isProffitAdmin),
            // クライアントは責任者変更ラベルを表示してもOK
            isShowAdminLabel: true,
            lastName: member.last_name,
        }));
        const member = isClientUser
            ? rfpMembers.find((rfpMember) => rfpMember.client_id === id)
            : null;
        let isActionDisabled = !member && !isRequestProfessional;
        if (isProffitAdmin) {
            isActionDisabled = false;
        }
        return {
            isActionDisabled,
            isCanUpdateMember: !!member || isProffitAdmin,
            isMember: !!member,
            isMemberAdmin: !!(member && member.is_admin),
            members,
        };
    }, [
        rfpMembers,
        requestProfessionalOrganizationId,
        id,
        organizationId,
        isProffitAdmin,
        auth,
    ]);
};
const useIsAdmin = (profile) => isAdmin(profile);
const useOffers = (rfp) => {
    const { view_requests: viewRequests } = rfp || {};
    return useMemo(() => {
        const keys = [
            {
                adjust: -1,
                name: 'charm_point',
            },
            'charm_point_seq',
        ];
        return (viewRequests || [])
            .filter((v) => v.offer)
            .sort((a, b) => arraySortFuncMultiKeys(a.offer, b.offer, keys));
    }, [viewRequests]);
};
export const rfpOneUseCase = {
    useIsAdmin,
    useMemberInfo,
    useOffers,
};
